import moment from 'moment-timezone'
import * as userService from '@/services/user'
import * as vehicleTypeService from '@/services/vehicle-types'
import * as authService from '@/services/auth'
import * as teammatesService from '@/services/teammates'
import { fetchPartnerManagerContact } from '@/services/partner-manager'
import { fetchOrderAssignments } from '@/services/order-assignments'
import { fetchCarrierInvoicingTerms } from '@/services/payment-period-update'
import { savePreferedLanguage } from '@/services/language-change'
import { OrderAssignmentState } from '@/services/models/order-assignments-model'
import { isBannerOpen } from './getters'

export const fetchCurrentUser = async ({ commit }) => {
  const currentUser = await userService.fetchCurrentUser()
  moment.tz.setDefault(currentUser.timezone)
  commit('setCurrentUser', currentUser)
  commit('setUserGroups', currentUser.groupNames)
}

export const fetchCarrierPartnerManager = async ({ commit }) => {
  const contact = await fetchPartnerManagerContact()
  commit('setCarrierPartnerManager', contact)
}

export const fetchVehicleTypes = async ({ commit }) => {
  const types = await vehicleTypeService.fetchVehicleTypes()
  commit('setVehicleTypes', types)
}

export const triggerReload = ({ commit }) => {
  commit('setShouldReloadState', true)
  setTimeout(() => {
    commit('setShouldReloadState', false)
  }, 2000)
}

export const fetchTeamMembers = async store => {
  const result = await teammatesService.fetch()
  store.commit('setTeamMembers', result)
}

export const inviteTeamMembers = async (store, teammatesIds) => {
  await teammatesService.invite(teammatesIds)
  store.dispatch('fetchTeamMembers')
}

export const loadOpenAssignments = async store => {
  const {
    pagination: { totalCount }
  } = await fetchOrderAssignments({ state: OrderAssignmentState.Pending })
  if (store.state.openAssignmentsCount !== totalCount)
    store.commit('setOpenAssignmentsCount', totalCount)
}

export const checkBackendHealth = async () => {
  await authService.checkBackendHealth()
}

export const resetStore = async ({ commit }) => {
  // global reset mutation must be present in all the module's mutations (in case we namespace modules
  // at some point, those must be committed explicitly: https://github.com/vuejs/vuex/issues/1118#issuecomment-356025807)
  commit('reset')
}

export const fetchPaymentPeriodDetails = async ({ commit }) => {
  const carrierCompany = await fetchCarrierInvoicingTerms()
  commit('setCarrierCompany', carrierCompany)
}

export const savePreferedLanguages = async (store, language) => {
  await savePreferedLanguage(language)
  store.commit('setCurrentUserLanguage', language)
}
